module.exports = __webpack_public_path__ + "img/4.184deed7.jpg";